<template>
<div style="width: 100vw; height: 100vh;overflow-y: auto;background: #f6f7f8;overflow-x: hidden">
  <van-nav-bar @click-left="onClickLeft" :border="false">
    <span slot="left" style="font-size: 17px">
       <van-icon color="black" name="arrow-left"></van-icon>
    </span>
    <span slot="title" style="font-size: 17px;color: #505050">门店列表</span>
  </van-nav-bar>
  <div style="padding: 4.8vw 3.2vw 4.8vw">
    <div v-for="item in list" @click="$router.push('/doorInfo?id=' + item.id)" :key="item" style="width: 100%; display: block; box-shadow: none;background: white;position: relative;margin: 2.4vw 0">
      <div style="margin: 0;width: 100%;height: 100%;display: flex">
        <div style="position: relative; width: 28.53vw; height: 28.53vw; display: inline-block;">
          <div style="background-color: #ffffff; height: 100%; width: 100%"  class="centerBox">
            <img :src="item.imgPath" style="width: 19.73vw; height: 19.73vw;border-radius: 1.3vw" >
          </div>
        </div>
        <div class="shopListInfo" style="">
          <div style="font-size: 3.73vw; width: 55vw; margin-top: 4.27vw;font-weight: bold;color: #505050" class="primaryText">
                      {{item.storeName}}
<!--            门店名称门店名称门店名称门店名称门店名称门店名称-->
          </div>
          <div style="width: 55vw;margin: 3.47vw 0 3.47vw;color: #ababab;font-size: 2.67vw" class="primaryText">
            <img src="../../assets/img/door/address.png" style="width: 2.93vw;margin-right: 1.87vw;transform: translateY(.4vw)">
           门店地址 {{item.storeAddress}}
          </div>
          <div style="width: 55vw;color: #ababab;font-size: 2.67vw" class="primaryText">
            <img src="../../assets/img/door/time.png" style="width: 2.93vw;margin-right: 1.87vw;transform: translateY(.4vw)">
            加入时间 {{$utils.ymdDate(item.createTime, '-')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'index',
  data: function () {
    return {
      show: false,
      icon: {
      },
      orderInfo: {
        deliveryInfo: {},
        orderItems: [],
        deliveryMsg: []
      },
      list: [],
      isFreightShow: false,
      couponShow: false,
      orderShow: false,
      userData: {}
    }
  },
  created () {
    this.listStore()
    // this.orderById()
    // this.userInfo()
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    orderPop () {
      this.show = true
    },
    rightButton (id) {
      this.$router.push({name: 'ShopInfo', query: {id}})
    },
    listStore () {
      const self = this
      let loading = self.$toast.loading({
        duration: 0
      })
      self.$request.shopCar.listStore()
              .then((response) => {
                loading.clear()
                if (response.code === '200') {
                  self.list = response.data
                } else {
                  self.$toast(response.msg)
                }
              })
    },
  }
}
</script>

<style scoped>

</style>
